import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth.service';
// import { TaskStatuses } from 'app/tasks/task.constants';

declare const $: any;
let self: any;

@Component({
  selector: 'app-create-modal',
  templateUrl: './create-modal.component.html',
  styleUrls: ['./create-modal.component.css']
})
export class CreateModalComponent {
  dialog: MatDialogRef<any>;
  // taskStatuses = TaskStatuses;

  constructor(
    private _AuthService: AuthService,
    public dialogRef: MatDialogRef<any>,
    private router: Router,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {

  }

  openNewQuoteModal() {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'quotes'], { queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }

  openNewTaskModal(status: string) {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-list'], { queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }

  openNewBDocumentModal() {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'billing-documents'], {  queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }

  openNewWorkerModal() {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'workers'], { queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }

  openNewClientModal() {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'clients'], { queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }

  openNewUserModal() {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'users'], { queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }

  openNewCategoryModal() {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'categories'], { queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }

  openNewProductModal() {
    this.dialog.close();
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'products'], { queryParams: { action: 'NEW', tp: new Date().getTime() } });
  }
}